module.exports = __webpack_public_path__ + "assets/images/EU-Capital-Tree-BG.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/EU-Capital-Tree-BG.jpg
 ** module id = 32
 ** module chunks = 0
 **/